import { RadioButton } from "@centricsoftware/design-system";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { useAttributeDefinitionStore } from "./AttributeDefinitionStore";

const AttributeDefinitionSectionREST: FunctionComponent = observer(() => {
	const { 
		attrRESTAccess,
		isBuiltInAttribute,
		locale,
		onChangeRESTAccess,
		restAccessOptions,
	} = useAttributeDefinitionStore();

	const { labelRESTRes } = locale;

	if (isBuiltInAttribute) {
		return;
	}

	return (
		<RadioButton
			ariaLabelRes={labelRESTRes}
			labelRes={labelRESTRes}
			onChange={onChangeRESTAccess}
			options={restAccessOptions}
			value={attrRESTAccess}
		/>
	);
});

export default AttributeDefinitionSectionREST;